import React from 'react'
import AnellLogo from "../../assets/Anell.png"

const Loading = () => {
  return (
    <div className='flex items-center justify-center min-h-[70vh] w-full bg-white'>
        <div className="relative flex items-center justify-center">
            {/* Outer spinning ring with gradient */}
            <div className="w-48 h-48 rounded-full border-4 border-transparent border-t-[#021d53] border-r-[#021d53]/30 animate-spin"></div>
            
            {/* Inner static/slow pulse container for logo */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-36 h-36 bg-white rounded-full flex items-center justify-center p-4 shadow-sm">
                  <img 
                    src={AnellLogo} 
                    alt="Anell School of Excellence" 
                    className="h-20 w-auto object-contain animate-pulse"
                  />
              </div>
            </div>
        </div>
    </div>
  )
}

export default Loading